import styled from "styled-components";

export const Container = styled.header`
    width: 100%;
    height: 72px;
`;